/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {TableInvoices} from './components/TableInvoices'
import {useAuth} from '../../modules/auth'
import {TableInvoicesV2} from './components/TableInvoicesV2'
import useSize from '../../hooks/useSize'

const invoicesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Início',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const InvoicesPage: FC = () => {
  const user = useAuth()
  return (
    <div className='column g-5 g-xl-8'>
      {user.currentUser?.role.slug === 'CLIENTE' ? (
        <TableInvoicesV2 className='card-xl-stretch mb-xl-8' />
      ) : (
        <TableInvoices className='card-xl-stretch mb-xl-8' />
      )}
    </div>
  )
}

const InvoicesWrapper: FC = () => {
  const {width} = useSize()

  return (
    <>
      <PageTitle breadcrumbs={invoicesBreadcrumbs}>
        {width < 1200 ? 'Minhas Faturas' : 'Gerenciamento de Faturas'}
      </PageTitle>
      <InvoicesPage />
    </>
  )
}

export {InvoicesWrapper}
